// extracted by mini-css-extract-plugin
module.exports = {"form_radio_btn":"radio_form_radio_btn__1foxo"};